const reservedFallbackCategory = 'fallbackCategory';

function correctCategory(category) {
    if(category.trim().length <= 0) {
        return reservedFallbackCategory;
    }
    return category;
}

const defaultState = {
    scrollIndex: {fallbackCategory: 0}
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'ARP_PREV_SCROLL': {
            let { payload } = action; // Payload is the category

            const { scrollIndex } = state;
            const newScrollIndex = scrollIndex;

            payload = correctCategory(payload);

            if(!hasOwnProperty.call(newScrollIndex, payload)) {
                newScrollIndex[payload] = 0;
            }

            newScrollIndex[payload] -= 1;

            return {
                ...state,
                scrollIndex: newScrollIndex
            };
        }
        case 'ARP_NEXT_SCROLL': {
            let { payload } = action; // Payload is the category

            const { scrollIndex } = state;
            const newScrollIndex = scrollIndex;
            
            payload = correctCategory(payload);

            if(!hasOwnProperty.call(newScrollIndex, payload)) {
                newScrollIndex[payload] = 0;
            }

            newScrollIndex[payload] += 1;

            return {
                ...state,
                scrollIndex: newScrollIndex
            };
        }
        default: {
            return state;
        }
    }
}